import { render, staticRenderFns } from "./EmailModel.vue?vue&type=template&id=35652e12&scoped=true"
import script from "./EmailModel.vue?vue&type=script&lang=js"
export * from "./EmailModel.vue?vue&type=script&lang=js"
import style0 from "./EmailModel.vue?vue&type=style&index=0&id=35652e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35652e12",
  null
  
)

export default component.exports